import { createSlice } from "@reduxjs/toolkit";
import { fetchDailyStock } from "./thunk";

interface DailyStockState {
  DailyStockList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DailyStockState = {
  DailyStockList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DailyStocklice = createSlice({
  name: "DailyStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDailyStock.fulfilled, (state, action) => {
        state.loading = false;
        state.DailyStockList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDailyStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default DailyStocklice.reducer;
